/**
 * Author:hong.rong
 * Desc:素材盘接口请求
 * Date:2022-09-15
 */

import requestHelper from '@/utils/requestHelper'

/**
 * 获取文件夹信息
 * @param data
 */
export async function getDirInfo(data) {
  return requestHelper.post('v4/demand/creativity/pan/personal/dir/info', data)
}
